export default __webpack_public_path__ + "static/media/Thundercloud_primary.2f5c140f.jpg";